module.exports = __webpack_public_path__ + "static/img/bg-index.41fd479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-index.png
// module id = WC0f
// module chunks = 159